import { render, staticRenderFns } from "./CSCompletedRequests.vue?vue&type=template&id=a5b6756c&scoped=true&"
import script from "./CSCompletedRequests.vue?vue&type=script&lang=js&"
export * from "./CSCompletedRequests.vue?vue&type=script&lang=js&"
import style0 from "./CSCompletedRequests.vue?vue&type=style&index=0&id=a5b6756c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b6756c",
  null
  
)

export default component.exports